<template>
  <v-dialog v-model="dialog" max-width="420">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        rounded
        block
        color="info"
        :loading="loading"        
        >Trocar para este plano</v-btn
      >
    </template>
    <v-card>
      <v-card-title>Alterar plano</v-card-title>
      <v-card-text class="subtitle-1">

        Confirma solicitação de alteração de plano de <b>{{ meuPlano.descplano }}</b> para <b>{{ planos.find((p) => p.codigo == planoSelecionado).descricao }}</b> ??

      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text rounded @click="solicitarAlteracaoDoPlano()" color="success">Sim, trocar plano</v-btn>
        <v-btn @click="dialog = false" text rounded>Não</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  computed: mapState("planoSaude", ["planoSelecionado","meuPlano","planos"]),
  data: () => ({
    loading: false,
    dialog: false,
  }),
  methods: {
    async solicitarAlteracaoDoPlano() {
      this.loading = true;
      await axios
        .post(
          "/colaborador/plano-saude/alterar-plano",
          JSON.stringify({
            codplano: this.planoSelecionado,
          })
        )
        .then((res) => {
          if (res.data.success) {
            this.$toasted.success(res.data.msg);
            this.$router.push({ path: "/plano-saude" });
          } else this.$toasted.error(res.data.msg);
        })
        .catch((e) => this.$toasted.error(e));
      this.loading = false;
    },
  },
};
</script>

<style>
</style>